import { TransactionsInterface } from './interfaces';

export const transactionInitialState: TransactionsInterface = {
  transactions: [],
};
